// extracted by mini-css-extract-plugin
module.exports = {"tableMain":"index-module--tableMain--Szw36","table":"index-module--table--2cXfF","improve":"index-module--improve--16zjc","hide":"index-module--hide--3Nzwo"};